
const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;

export const difficultyImages = {
  0: `${baseImagePath}scale/s0.png`,
  1: `${baseImagePath}scale/s1.png`,
  2: `${baseImagePath}scale/s2.png`,
  3: `${baseImagePath}scale/s3.png`,
  4: `${baseImagePath}scale/s4.png`,
  5: `${baseImagePath}scale/s5.png`,
  11: `${baseImagePath}scale/s1_s.png`,
  22: `${baseImagePath}scale/s2_s.png`,
  33: `${baseImagePath}scale/s3_s.png`,
  44: `${baseImagePath}scale/s4_s.png`,
  55: `${baseImagePath}scale/s5_s.png`,
};
